import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SignableDocumentRow } from "@/components/SignableDocumentRow";
import { ExpedienteChecklist } from "@/components/ExpedienteChecklist";
import { DOCUMENT_LIBRARY } from "@/constants/testIds";

// Checklist de firma de esta persona (uno por documento: automático si fue electrónico con
// respaldo físico subido, o manual con nota si RH lo marcó como firmado en papel). Reutiliza
// exactamente el mismo componente y las mismas acciones que la Biblioteca de Documentos.
export function DocumentsTab({ employeeId }) {
  const [docs, setDocs] = useState([]);

  const load = () => {
    api.get(`/employees/${employeeId}/signable-documents`).then(({ data }) => setDocs(data));
  };

  useEffect(load, [employeeId]);

  const handleDownloadPdf = async (doc) => {
    const { data } = await api.get(`/signable-documents/${doc.id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${doc.title}.pdf`;
    a.click();
  };

  return (
    <div data-testid={DOCUMENT_LIBRARY.employeeDetailDocumentsTab} className="space-y-3 mt-4">
      <ExpedienteChecklist employeeId={employeeId} generatedDocs={docs} />
      {docs.map((d) => (
        <SignableDocumentRow key={d.id} doc={d} onDownloadPdf={handleDownloadPdf} onChanged={load} />
      ))}
      {docs.length === 0 && <p className="text-charcoal/50 text-sm">Sin documentos de firma generados para esta persona.</p>}
    </div>
  );
}
